'use strict';
const getValueForKeyArray = require('@mindmup/js-utils/src/get-value-for-key-array'),
	isObjectObject = require('@mindmup/js-utils/src/is-object-object');
module.exports = function dereference(params) {
	if (!params) {
		throw new Error('invalid-args');
	}
	const {prefix, target, currentObject} = params,
		findOverridesIn = currentObject || target,
		dereferenceValue = (currentVal) => {
			if (typeof currentVal === 'string' && currentVal.startsWith(prefix)) {
				const keyArray = currentVal.slice(prefix.length).split('.'),
					replacedVal = getValueForKeyArray({target, keyArray});
				if (typeof replacedVal === 'string' && replacedVal.startsWith(prefix)) {
					throw new Error('referencing-reference-value');
				}
				return replacedVal;
			}
			return currentVal;
		},
		dereferenceProperty = (object, property) => {
			const currentVal = object[property];
			if (typeof currentVal === 'string') {
				object[property] = dereferenceValue(currentVal);
			} else if (isObjectObject(currentVal)) {
				dereference({prefix, target, currentObject: currentVal});
			} else if (Array.isArray(currentVal)) {
				currentVal.forEach((val, idx) => {
					const arrayValue = currentVal[idx];
					if (isObjectObject(arrayValue)) {
						dereference({prefix, target, currentObject: currentVal[idx]});
					} else {
						currentVal[idx] = dereferenceValue(arrayValue);
					}
				});
			}
		};
	if (!prefix || !target || !isObjectObject(target)) {
		throw new Error('invalid-args');
	}
	Object.keys(findOverridesIn).forEach(key => dereferenceProperty(findOverridesIn, key));

	return target;
};
